import { Sparkle } from "@phosphor-icons/react";

/**
 * Significance progress panel. Shows chi-square confidence % + progress bar
 * toward min-clicks threshold.
 */
export default function SignificanceStatus({
  sigReached,
  confidence,
  totalClicks,
  minClicks,
}) {
  const progress = Math.min(100, (totalClicks / minClicks) * 100);
  const remaining = Math.max(0, minClicks - totalClicks);
  return (
    <div
      className={`mb-4 p-3 border ${
        sigReached
          ? "border-[#ccff00]/40 bg-[#ccff00]/5"
          : "border-white/10 bg-[#121212]"
      }`}
      data-testid="significance-status"
    >
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <Sparkle
            size={13}
            weight="fill"
            className={sigReached ? "text-[#ccff00]" : "text-zinc-500"}
          />
          <span className="font-mono text-[10px] uppercase tracking-[0.2em]">
            {sigReached
              ? "significance reached · 95%+"
              : "significance progress"}
          </span>
        </div>
        <span className="font-mono text-[10px] text-zinc-400">
          {confidence.toFixed(1)}% conf
        </span>
      </div>
      <div className="h-1 bg-[#050505] border border-white/5 overflow-hidden">
        <div
          className="h-full transition-all duration-500"
          style={{
            width: `${sigReached ? 100 : progress}%`,
            backgroundColor: sigReached ? "#ccff00" : "#3f3f46",
          }}
        />
      </div>
      {!sigReached && (
        <div className="font-mono text-[10px] text-zinc-500 mt-2">
          {remaining} more clicks needed for auto-caller
        </div>
      )}
    </div>
  );
}
